<template>
    <div class="Carrinho">
        <Header></Header>

        <div class="container" style="min-height: 42vh">
            <div class="row">
                <div class="col-8 col-md-8 mt-5">
                    <div class="row text-center d-block" v-if="treinamentos.length == 0">
                        <div class="col-lg-12 col-md-12">
                            <h3 class="txt-p txt-size-25 txt-w-7 txt-blue-3">Oops!</h3> 
                            <p class="txt-p txt-size-14 txt-w-4 txt-blue-3">Nenhum item no carrinho.</p>
                        </div>
                    </div>
                    <div class="" v-else>
                        <section class="itemcarrinho mb-2 item-carrinho" v-for="(item,index) in treinamentos" :key="index">
                            <div class="row linha-curso position-relative">
                                <div class="remover-curso text-right d-inline d-sm-none" style="position: absolute; right: 4px; top: 2px; z-index: 1;">
                                    <button class="btn btn-remover" @click="removerCarrinho(item.idTreinamento)" style="padding: 2px 8px;"><i class="fa fa-times" aria-hidden="true"></i></button>
                                </div> 
                                <div class="col-12 col-sm-3 img-curso">
                                    <router-link :to="{name:'Curso', params:{id:item.idTreinamento}}">
                                        <img class="visible-md-block w-100" :src="(item.urlImagemCapa==null?'img-default-curso.png':item.urlImagemCapa)" onerror="this.onerror=null; this.src='/img-default-curso.png'" >
                                    </router-link>
                                </div> 
                                <div class="col-12 col-sm-7 dados-curso">
                                    <router-link :to="{name:'Curso', params:{id:item.idTreinamento}}">
                                        <span class="m-0 p-0">{{item.nmTreinamento}}</span>
                                        <p class="m-0 p-0 mt-1 text-justify">{{item.qtdAulas}} aulas disponíveis. {{item.duracaoTreinamento}} horas. {{item.nmCategoria}}</p>
                                    </router-link>
                                </div> 
                                <div class="col-12 col-sm-2 remover-curso text-right">
                                    <button class="btn btn-remover d-none d-sm-inline" @click="removerCarrinho(item.idTreinamento)"> Remover </button> 
                                    <p class="mt-2 vlr-treinamento">R$ {{moeda(item.vlTreinamento)}}</p>
                                </div>
                            </div>
                        </section>
                    </div>
                </div> 
                <div class="col-4 col-md-4 bg-cinza" v-if="treinamentos">
                    <div class="row mt-5">
                        <div class="col-12 col-sm-12 total-itens pb-2">
                            <span class="txt-p txt-size-14 txt-w-4 txt-blue-3">
                                {{treinamentos.length}} itens no carrinho
                            </span>
                        </div> 
                        <div class="col-12 col-sm-12 total-title pb-2">
                            <span class="txt-p txt-size-16 txt-w-8 txt-blue-3">
                                Total:
                            </span>
                        </div> 
                        <div class="col-12 col-sm-12 valor-total pb-2">
                            <span class="txt-p txt-size-24 txt-w-7 txt-blue-3">
                                R$ {{totalCarrinho}}
                            </span>
                        </div> <!----> <!----> 
                        <div class="col-12 col-sm-12 div-btn-finalizar"><!---->
                            <router-link v-if="treinamentos.length > 0" class="btn btn-yellow w-100 pt-2 pb-2" :to="{name:'Compra'}">
                                finalizar compra
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Footer class="mt-5"></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'

    import { urlApi, avisoErro, numeroParaMoeda } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'Carrinho',
        components: { Header, Footer },
        data: function () {
            return {
                treinamentos: [],              
            }
        },
        computed: {
            user() {
                return this.$store.state.user
            },
            carrinho() {
                return this.$store.state.carrinho
            },
            totalCarrinho() {
                if (this.treinamentos && this.treinamentos.length > 0) {
                    var total = 0;
                    for (let i = 0; i < this.treinamentos.length; i++) {
                        total += this.treinamentos[i].vlTreinamento;
                    }
                    return numeroParaMoeda(total);
                } else {
                    return 0;
                }

            },
        },
        methods: {
            

            getTreinamento(id) {
                let $this = this;
                axios.get(`${urlApi}/Treinamento/Get/${id}`)
                    .then(res => {
                        if (res.data.success) {
                            if (res.data.data != null) {
                                var treinamento = res.data.data.treinamento;
                                treinamento.categoria = res.data.data.categoria;
                                $this.treinamentos.push(treinamento);
                            }
                        } else {
                            avisoErro("Não foi possível carregar o curso");
                            $this.removerCarrinho(id);
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar o curso");
                        $this.removerCarrinho(id);
                    });
            },

            load() {
                let $this = this;
                $this.treinamentos = [];
                if (this.carrinho && this.carrinho.length > 0) {
                    for (let i = 0; i < this.carrinho.length; i++) {
                        var item = this.carrinho[i];

                        $this.getTreinamento(item.idTreinamento);
                    }
                }
               
            },

            removerCarrinho(idTreinamento) {
                let $this = this;
                var carrinho = $this.carrinho.filter(x => x.idTreinamento != idTreinamento);
                $this.$store.commit('setCarrinho', carrinho);
                $this.load();
            },


            moeda(vlTreinamento) {
                return numeroParaMoeda(vlTreinamento);
            },

            
        },
        created: function () {
            this.load();
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

    .itemcarrinho {

        .linha-curso {
            border: 1px solid #D1D1D1;
            border-radius: 5px;
            padding: 10px 0;
            margin: 0;

            .link-curso:hover {
                text-decoration: none;
            }

            .dados-curso {
                
            }

            .remover-curso .btn-remover {
                background-color: #B56363;
                color: #fff;
                border-radius: 5px;
                font-size: 13px;
            }

            .remover-curso .btn-remover:hover {
                background-color: #D35656;
            }

            .remover-curso .vlr-treinamento {
                font-style: normal;
                font-weight: bold;
                font-size: .8rem;
                line-height: 140.62%;
                color: #163142;
            }
        }
    }
</style>

